<template>
    <div>
        <drawer-menu
            v-if="mobile && hasSelectedUnit && hasSegmentations"
            :value="drawer"
            :routes="routes"
            @logout="logout"
            @close="drawer = false"
        ></drawer-menu>
        <v-toolbar
            app
            clipped-left
            class="navbar"
            :class="{ navbar__lg: $vuetify.breakpoint.lgAndUp }"
            :extended="!mobile && !!user && !!selectedUnit && hasSegmentations"
            extension-height="50px"
            :style="{ boxShadow: user
                ? 'none'
                : '0px 1px 5px #d0d0cd'
            }"
        >
            <Menu slot="extension"
                v-if="!mobile && hasSelectedUnit && hasSegmentations"
                :routes="routes"
            ></Menu>
            <v-btn
                icon
                v-if="mobile && hasSelectedUnit"
                @click.stop="drawer = !drawer"
                class="no-print"
            >
                <i class="bexsicon-menu" />
            </v-btn>
            <v-spacer
                v-if="mobile"
            ></v-spacer>
            <img
                :src="logoImage"
                @click="$router.push({ name: 'home' })"
                class="navbar__brand-logo"
            />
            <span v-if="stage && mobile">
                <span class="navbar__stage-exhibition">{{ stage }}</span>
            </span>
            <div
                v-if="!mobile"
                class="navbar__partition"
            >
                {{ getPortalLabel }}
                <span v-if="stage && !mobile">
                    - <span class="navbar__stage-exhibition">{{ stage }}</span>
                </span>
            </div>
            <v-spacer></v-spacer>
            <notification
                v-if="hasSelectedUnit && shouldShowNotifications"
                @clicked="notificationClicked"
                :items="notifications"
                class="no-print"
            ></notification>
            <div
                v-if="!mobile && user"
                class="navbar__partition no-print"
            >
                Olá, {{ userFirstName }}
            </div>
            <div
                v-if="!mobile && user"
                class="navbar__partition --last-partition"
            >
                <div
                    class="navbar__partition__action no-print"
                    @click="logout"
                >
                    sair
                </div>
            </div>
        </v-toolbar>
    </div>
</template>

<script>
import Menu from '@/components/layout/Menu';
import Notification from '@/components/Notification';
import DrawerMenu from '@/components/layout/DrawerMenu';
import { hasPermission } from '@/utils';
import enums from '@/utils/enums';
import { UNIT } from '../../utils/constants';
export default {
  name: 'navbar',
  components: {
    Notification,
    DrawerMenu,
    Menu
  },
  computed: {
    shouldShowNotifications() {
      return hasPermission(enums.notificationsProfiles);
    },
    hasSelectedUnit() {
      return this.user && this.selectedUnit;
    },
    hasSegmentations() {
      return this.$store.getters[UNIT.GET_SEGMENTATIONS].length > 0;
    },
    getPortalLabel() {
      return this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? 'portal do síndico'
        : 'portal do cliente';
    }
  },
  props: {
    routes: {
      type: Array,
      required: true
    },
    notifications: {
      type: Array,
      required: true
    },
    logoImage: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      drawer: false,
      stage: ''
    };
  },
  created() {
    if (
      process.env.STAGE === 'homolog' ||
      process.env.STAGE === 'qa' ||
      process.env.STAGE === 'dev'
    ) {
      this.stage = process.env.STAGE.toUpperCase();
    }
  },
  methods: {
    notificationClicked(item) {
      this.$emit('notificationClicked', item);
    },
    logout() {
      this.$emit('logout');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.drawer {
  z-index: 9999999;
}

>>> .v-toolbar__content {
  max-width: 1366px;
  margin: auto;
}

>>> .v-toolbar__extension {
  padding: 0;
  box-shadow: -10px 5px 12px -7px #0000006f;
}

.navbar {
  height: fit-content;
  z-index: 200;
  padding: 0;

  &__lg {
    >>> .v-toolbar__extension {
      padding: 0;
      width: 102%;
    }
  }

  @include breakpoint(not-mobile) {
    // height: 6%;
  }

  @include breakpoint(mobile) {
    box-shadow: 0px 1px 5px #d0d0cd !important;
  }

  i {
    font-size: var(--icon-size);
    color: var(--brand-color);
  }

  .--last-partition {
    color: var(--brand-color);
  }

  &__partition {
    padding: 0.95em 1em;
    text-transform: capitalize;
    font-size: 1em;
    border-left: 1px solid var(--border-light-color);
    color: var(--label-color);

    &__action {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__brand-logo {
    height: auto;
    cursor: pointer;

    @include breakpoint(tablet) {
      width: 150px;
    }
    @include breakpoint(mobile) {
      width: 184px;
      height: 40px;
    }
    @include breakpoint(not-mobile) {
      width: 150px !important;
      margin: 0 1em !important;
    }
  }

  &__stage-exhibition {
    font-size: 18px;
    color: #ff530eed;

    @include breakpoint(mobile) {
      padding: 0 0 0 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue